"use client";

import Link from "next/link";
import BrandLogo from "@/components/tenant/BrandLogo";
import { useTenant } from "@/components/tenant/TenantProvider";

/**
 * Potongan ber-branding tenant untuk halaman legal/bantuan.
 * Dipisah dari LegalPage.tsx agar LegalPage tetap server module
 * (halaman legal meng-import konstanta CONTACT_EMAIL darinya).
 */

export function LegalBrandLink() {
  const branding = useTenant();
  return (
    <Link href="/" className="flex items-center" aria-label={`${branding.brand_name} beranda`}>
      <BrandLogo width={128} height={32} className="h-7 w-auto" priority />
    </Link>
  );
}

/** Island kecil: render brand_name tenant di body halaman legal (server component). */
export function BrandName() {
  const branding = useTenant();
  return <>{branding.brand_name}</>;
}

/**
 * Varian bertombol untuk CTA "Email kami" di /help. Isinya sama-sama memakai
 * support_email tenant; dipisah karena LegalContactEmail memaksa gaya tautan
 * teks, sementara di sana bentuknya tombol.
 */
export function LegalContactEmailButton({
  fallback,
  className,
}: {
  fallback: string;
  className?: string;
}) {
  const branding = useTenant();
  const email = branding.support_email ?? fallback;
  return (
    <a href={`mailto:${email}`} className={className}>
      Email {email}
    </a>
  );
}

export function LegalContactEmail({ fallback }: { fallback: string }) {
  const branding = useTenant();
  const email = branding.support_email ?? fallback;
  return (
    <a href={`mailto:${email}`} className="text-primary hover:underline">
      {email}
    </a>
  );
}
